import axios from "axios";

// 🔁 Auto-switch: local emulator in dev, real Firebase URL in production
const baseURL =
  process.env.NODE_ENV === "production"
    ? "https://us-central1-markets-shop-with-me.cloudfunctions.net/api" // 🌐 Firebase production
    : "http://127.0.0.1:5006/markets-shop-with-me/us-central1/api";    // 💻 Local emulator

const instance = axios.create({ baseURL });

export default instance;

